import classNames from "classnames";

import ImageWrapper from "@components/swagmagic/dynamic/cards/image-wrapper";

import styles from "./main.module.scss";

const BrandCard = ({ src, title }: { src: string; title: string }) => {
  return (
    <div className={styles.cardContainer}>
      <ImageWrapper
        src={src}
        alt={title}
        imageWrapperClassName={classNames(styles.cardImageHolder)}
        imageClassName={styles.cardImage}
        noImageText={title}
      />
      <div className={styles.cardTitle}>{title}</div>
    </div>
  );
};

export default BrandCard;
